var map = {
	"./assets/A1.png": 3881,
	"./assets/A2.png": 2517,
	"./assets/A3.png": 289,
	"./assets/A4.png": 5424,
	"./assets/A5.png": 4474,
	"./assets/A6.png": 8499,
	"./assets/AIGC2x.png": 5666,
	"./assets/AIGC_large.svg": 9686,
	"./assets/AIGC_large.webp": 4559,
	"./assets/Frame.svg": 6785,
	"./assets/Group137.svg": 9024,
	"./assets/Group137_1.svg": 1920,
	"./assets/Group137_1.webp": 1772,
	"./assets/Group138.svg": 3452,
	"./assets/Group139.svg": 8478,
	"./assets/Group139.webp": 4949,
	"./assets/Group139_1.svg": 7434,
	"./assets/Group139_1.webp": 2367,
	"./assets/Group_137.webp": 7617,
	"./assets/Group_138.webp": 7729,
	"./assets/Group_138_1.webp": 4108,
	"./assets/about.png": 4722,
	"./assets/ai/AIGC.png": 1465,
	"./assets/ai/Group52.png": 404,
	"./assets/ai/Group52_1.png": 9687,
	"./assets/ai/Group53.png": 8123,
	"./assets/ai/Group53_1.png": 8254,
	"./assets/ai/Group54.png": 9661,
	"./assets/ai/Group54_1.png": 5887,
	"./assets/ai/Group55.png": 1015,
	"./assets/ai/Group55_1.png": 2011,
	"./assets/ai/Group56.png": 4515,
	"./assets/ai/Group56_1.png": 4916,
	"./assets/ai/solution1.png": 7269,
	"./assets/ai/solution2.png": 4589,
	"./assets/ai/solution3.png": 4937,
	"./assets/ai/一站式.png": 3205,
	"./assets/ai/多元化.png": 5422,
	"./assets/ai/性价比.png": 9002,
	"./assets/ai/高性能加持.png": 8905,
	"./assets/back.png": 84,
	"./assets/bottom_bg.png": 5702,
	"./assets/logo.svg": 9574,
	"./assets/mail.png": 9698,
	"./assets/news/news.jpg": 6028,
	"./assets/news/广告图.png": 6962,
	"./assets/service/1.png": 7813,
	"./assets/service/2.png": 9286,
	"./assets/service/3.png": 7454,
	"./assets/service/4.png": 4560,
	"./assets/service/AIGC.png": 8992,
	"./assets/service/Group106.png": 7322,
	"./assets/service/Group107.png": 8413,
	"./assets/service/Group108.png": 3737,
	"./assets/service/Group109.png": 3624,
	"./assets/service/Group110.png": 8872,
	"./assets/service/Group1101.png": 3032,
	"./assets/service/Group1102.png": 1786,
	"./assets/service/Group1103.png": 5878,
	"./assets/service/Group1104.png": 7106,
	"./assets/service/Group1105.png": 1523,
	"./assets/service/Group1106.png": 7865,
	"./assets/service/Group111.png": 9148,
	"./assets/service/Group119.png": 9617,
	"./assets/service/Group120.png": 3773,
	"./assets/service/Group121.png": 4476,
	"./assets/service/Group126.png": 4786,
	"./assets/service/arrow.png": 8054,
	"./assets/service/云产品.png": 8415,
	"./assets/service/云游戏1.png": 713,
	"./assets/service/云电脑.png": 7749,
	"./assets/service/前景覆层.png": 1395,
	"./assets/service/背景装饰.png": 8261,
	"./assets/service/背景装饰2.png": 6059,
	"./assets/service/装饰1.png": 2266,
	"./assets/solution/Group52.png": 8119,
	"./assets/solution/Group52_1.png": 1600,
	"./assets/solution/Group53.png": 9942,
	"./assets/solution/Group53_1.png": 5545,
	"./assets/solution/Group54.png": 4333,
	"./assets/solution/Group54_1.png": 3588,
	"./assets/solution/Group55.png": 2733,
	"./assets/solution/Group55_1.png": 2847,
	"./assets/solution/Group56.png": 7644,
	"./assets/solution/Group56_1.png": 2519,
	"./assets/solution/icon_1.png": 7885,
	"./assets/solution/icon_10.png": 4417,
	"./assets/solution/icon_11.png": 9405,
	"./assets/solution/icon_12.png": 8426,
	"./assets/solution/icon_13.png": 1607,
	"./assets/solution/icon_14.png": 4942,
	"./assets/solution/icon_15.png": 3003,
	"./assets/solution/icon_16.png": 2993,
	"./assets/solution/icon_17.png": 7864,
	"./assets/solution/icon_2.png": 1436,
	"./assets/solution/icon_3.png": 7017,
	"./assets/solution/icon_4.png": 4690,
	"./assets/solution/icon_5.png": 953,
	"./assets/solution/icon_6.png": 1606,
	"./assets/solution/icon_7.png": 8309,
	"./assets/solution/icon_8.png": 9623,
	"./assets/solution/icon_9.png": 260,
	"./assets/solution/一键.png": 2114,
	"./assets/solution/云游戏.png": 4612,
	"./assets/solution/传感器.png": 6069,
	"./assets/solution/前景覆层.png": 222,
	"./assets/solution/发行.png": 3220,
	"./assets/solution/启动.png": 6279,
	"./assets/solution/平台.png": 6665,
	"./assets/solution/微端.png": 5777,
	"./assets/solution/控制权.png": 4143,
	"./assets/solution/支付.png": 3988,
	"./assets/solution/文件.png": 2121,
	"./assets/solution/更新.png": 748,
	"./assets/solution/游戏.png": 2328,
	"./assets/solution/画质.png": 8448,
	"./assets/solution/直播.png": 5934,
	"./assets/solution/背景装饰.png": 6747,
	"./assets/solution/适配.png": 3815,
	"./assets/solutionCloudGame/Group52.png": 4314,
	"./assets/solutionCloudGame/Group52_1.png": 844,
	"./assets/solutionCloudGame/Group53.png": 1169,
	"./assets/solutionCloudGame/Group53_1.png": 1569,
	"./assets/solutionCloudGame/Group54.png": 1674,
	"./assets/solutionCloudGame/Group54_1.png": 3552,
	"./assets/solutionCloudGame/Group55.png": 9307,
	"./assets/solutionCloudGame/Group55_1.png": 9088,
	"./assets/solutionCloudGame/Group56.png": 5706,
	"./assets/solutionCloudGame/Group56_1.png": 8251,
	"./assets/solutionCloudGame/云电脑.png": 8863,
	"./assets/solutionCloudGame/多终端.png": 9679,
	"./assets/solutionCloudGame/平台.png": 9243,
	"./assets/solutionCloudGame/微端.png": 519,
	"./assets/solutionCloudGame/游戏.png": 9992,
	"./assets/solutionCloudGame/简单.png": 3094,
	"./assets/solutionCloudGame/轻量化.png": 387,
	"./assets/solutionCloudGame/高性能.png": 6809,
	"./assets/中国地图.svg": 5981,
	"./assets/主视觉.svg": 6090,
	"./assets/云平台.svg": 662,
	"./assets/云游戏.webp": 5595,
	"./assets/云电脑.webp": 6379,
	"./assets/优化.svg": 7513,
	"./assets/内容.svg": 9489,
	"./assets/前景覆层.svg": 7040,
	"./assets/协同.svg": 7634,
	"./assets/卫星.png": 6690,
	"./assets/发行.svg": 9906,
	"./assets/可靠.svg": 9159,
	"./assets/大模型.svg": 7121,
	"./assets/宇航员.svg": 7433,
	"./assets/微端.svg": 5826,
	"./assets/成本.svg": 1542,
	"./assets/文案.svg": 594,
	"./assets/新闻背景.svg": 1812,
	"./assets/新闻背景.webp": 7162,
	"./assets/方案.svg": 8797,
	"./assets/时效.svg": 6689,
	"./assets/桌面.svg": 542,
	"./assets/游戏2x.png": 5347,
	"./assets/游戏_large.svg": 8482,
	"./assets/灵活.svg": 9974,
	"./assets/电脑2x.png": 1995,
	"./assets/直播.svg": 711,
	"./assets/科幻背景.png": 9593,
	"./assets/科幻背景.svg": 6667,
	"./assets/网吧.svg": 441,
	"./assets/背景.svg": 5524,
	"./assets/背景图.svg": 5577,
	"./assets/背景层.svg": 8470,
	"./assets/背景层.webp": 1574,
	"./assets/资源.svg": 3053,
	"./assets/酒店.svg": 657,
	"./assets/里程碑背景.svg": 5770,
	"./assets/飞船.svg": 5730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;